module.exports = __webpack_public_path__ + "images/emoji/key.ffbe010f181e6649e229.png";